module.exports = __webpack_public_path__ + "static/assets/c841d8156cb6460bafadb8e04b1ff70a.svg";